import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'
import { useReportFilenameExampleQuery } from 'schema'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { Spin } from 'antd'
import { useDebounce } from 'hooks/useDebounce'
import { UseEditFilenameModal } from '../../EditFilenameModal/hooks/useEditFilenameModal/types'
import { ReportFilename } from '../ReportFilenamesContext/types'
import { useGlobalState } from '../../../../../../../../../../context/GlobalStateContext'

const ModalExample: React.FC<UseEditFilenameModal<ReportFilename>> = ({
  state,
  templateItems,
  valid,
}) => {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const [debouncedTemplateItems, debouncing] = useDebounce(templateItems, 1000)
  const { id } = state ?? {}
  const { data, loading } = useReportFilenameExampleQuery({
    ...DefaultQueryHookOptions,
    skip: !projectId || !id || !valid || debouncing,
    variables: {
      input: {
        reportId: id!,
        templateItems: debouncedTemplateItems,
        projectId: projectId!,
      },
    },
  })
  return (
    <CIMSFormItem label="Example" help={HelpMessage.Exports.Example}>
      <Spin size="small" spinning={debouncing || (loading ?? false)}>
        {data?.reportFilenameExample}
      </Spin>
    </CIMSFormItem>
  )
}

export default ModalExample
